export const GROOV_LOGO = "GroovLogo";
